import React from 'react';
import { Link } from 'react-router-dom';

// Adjust these imports to match your project structure
import LogoSVG from '../assets/BantrBoxLogo.svg';
import Footer from '../components/Footer';

const Privacy = () => {
  return (
    <div className="bg-white text-gray-800 min-h-screen flex flex-col">
      {/* Header Bar */}
      <header className="bg-[#333333] shadow-sm text-white">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img 
              src={LogoSVG} 
              alt="BantrBox Logo" 
              className="h-12 w-auto"
            />
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 py-10 px-4">
        <div className="max-w-4xl mx-auto space-y-6">
          <h1 className="text-4xl font-bold mb-4 leading-tight">Privacy Policy</h1>
          <p className="text-sm text-gray-500">
            Last Updated: 2024-12-16
          </p>

          <p className="leading-relaxed">
            Welcome to BantrBox. We are committed to respecting and protecting your privacy. 
            This Privacy Policy outlines how we collect, use, disclose, and safeguard your 
            personal information when you visit or use our platform (the “Service”).
          </p>

          <h2 className="text-2xl font-semibold mt-8">1. Information We Collect</h2>
          <p className="leading-relaxed">
            We may collect personal information that you choose to provide, such as your name, 
            email address, or other details needed to set up an account or participate in challenges. 
            We may also automatically collect certain information, including but not limited to 
            your IP address, browser type, operating system, and usage data to help us improve 
            the Service.
          </p>

          <h2 className="text-2xl font-semibold mt-8">2. How We Use Your Information</h2>
          <p className="leading-relaxed">
            We use your information to provide and maintain the Service, personalize user 
            experiences, send administrative and promotional communications, monitor usage, 
            and detect/prevent technical issues or fraudulent activities.
          </p>

          <h2 className="text-2xl font-semibold mt-8">3. Cookies and Similar Technologies</h2>
          <p className="leading-relaxed">
            We may use cookies, web beacons, and other tracking technologies to collect 
            information about your interactions with the Service. This helps us enhance 
            functionality, analyze usage patterns, and deliver a better overall experience. 
            You can manage your cookie preferences through your web browser settings.
          </p>

          <h2 className="text-2xl font-semibold mt-8">4. Sharing of Information</h2>
          <p className="leading-relaxed">
            We do not sell or rent your personal information. We may share your information 
            with third-party vendors who perform services on our behalf (e.g., analytics providers), 
            with your consent, or when required by law or to protect our rights and safety.
          </p>

          <h2 className="text-2xl font-semibold mt-8">5. Data Security</h2>
          <p className="leading-relaxed">
            We implement appropriate technical and organizational measures to protect your 
            personal data from unauthorized access or disclosure. However, no security system 
            is impenetrable, and we cannot guarantee the absolute security of your information.
          </p>

          <h2 className="text-2xl font-semibold mt-8">6. Third-Party Links</h2>
          <p className="leading-relaxed">
            Our Service may contain links to third-party websites or services not controlled 
            by us. We are not responsible for the content, privacy practices, or security of 
            such external sites. We recommend reviewing the privacy policies of any third-party 
            websites you visit.
          </p>

          <h2 className="text-2xl font-semibold mt-8">7. Children’s Privacy</h2>
          <p className="leading-relaxed">
            Our Service is not intended for individuals under the age of 13 (or the age of 
            majority in your jurisdiction). We do not knowingly collect personal information 
            from children. If you believe a child has provided us with personal information, 
            please contact us so we can remove it.
          </p>

          <h2 className="text-2xl font-semibold mt-8">8. Changes to This Policy</h2>
          <p className="leading-relaxed">
            We may update this Privacy Policy from time to time to reflect changes in our 
            practices. Any updates will be posted on this page, and the “Last Updated” date 
            will be revised accordingly. Your continued use of the Service after any such 
            updates indicates your acceptance of the revised policy.
          </p>

          <h2 className="text-2xl font-semibold mt-8">9. Your Choices &amp; Rights</h2>
          <p className="leading-relaxed">
            Depending on your location, you may have certain rights regarding your personal 
            data, such as the right to access, correct, delete, or restrict its use. You can 
            also opt out of receiving marketing communications from us by following the 
            unsubscribe instructions in our emails or contacting us directly.
          </p>

          <h2 className="text-2xl font-semibold mt-8">10. Contact Us</h2>
          <p className="leading-relaxed">
            If you have any questions or concerns about this Privacy Policy or our data 
            practices, please contact us at 
            <a href="mailto:support@bantrbox.com" className="text-blue-600 underline"> support@bantrbox.com</a>.
          </p>
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Privacy;
